import * as braze from '@braze/web-sdk'
import { useEffect, useRef, useState } from 'react'
import { useAppSelector } from './useRedux'
import { userSelector } from '@/pages/user/selectors'
import { BRAZE_API_KEY, BRAZE_API_URL } from '@/constants/Common'

export function useBraze() {
  const { user } = useAppSelector(userSelector)

  const [sdkIsInitialized, setSdkIsInitialized] = useState(false)
  const [userIsInitialized, setUserIsInitialized] = useState(false)
  const lastUserIdRef = useRef<string | null>(null)

  // init SDK lazily (only when a user shows up)
  useEffect(() => {
    if (user && !sdkIsInitialized) {
      braze.initialize(BRAZE_API_KEY, {
        baseUrl: BRAZE_API_URL,
        enableLogging: false,
        allowUserSuppliedJavascript: true,
      })

      setSdkIsInitialized(true)
    }
  }, [user, sdkIsInitialized])

  useEffect(() => {
    if (sdkIsInitialized && user) {
      const id = String(user.id)
      const changed = lastUserIdRef.current !== id

      if (!userIsInitialized || changed) {
        braze.automaticallyShowInAppMessages() // call before opening session
        braze.changeUser(id)
        braze.openSession()

        lastUserIdRef.current = id
        setUserIsInitialized(true)
      }
    }
  }, [sdkIsInitialized, user, userIsInitialized])

  // logout: close + wipe
  useEffect(() => {
    if (sdkIsInitialized) {
      // when user becomes null after being set
      if (!user && userIsInitialized) {
        braze.wipeData()

        lastUserIdRef.current = null
        setUserIsInitialized(false)
      }
    }
  }, [sdkIsInitialized, user, userIsInitialized])
}
